export enum TEXT_ICON_BUTTON_SIZES {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}

export enum TEXT_ICON_BUTTON_TYPES {
  ICON_RIGHT = 'icon-right',
  ICON_LEFT = 'icon-left',
  NO_ICON = 'no-icon',
  ONLY_CTA = 'only-cta',
}
